"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneCodes = exports.countryCodes = exports.COUNTRIES = void 0;
const country_regions_generated_1 = require("./country-regions.generated");
const country_tax_rates_generated_1 = require("./country-tax-rates.generated");
exports.COUNTRIES = [
    {
        countryName: "Afghanistan",
        phoneCode: "+93",
        countryCode: "AF",
    },
    {
        countryName: "Albania",
        phoneCode: "+355",
        countryCode: "AL",
    },
    {
        countryName: "Algeria",
        phoneCode: "+213",
        countryCode: "DZ",
    },
    {
        countryName: "AmericanSamoa",
        phoneCode: "+1684",
        countryCode: "AS",
    },
    {
        countryName: "Andorra",
        phoneCode: "+376",
        countryCode: "AD",
    },
    {
        countryName: "Angola",
        phoneCode: "+244",
        countryCode: "AO",
    },
    {
        countryName: "Anguilla",
        phoneCode: "+1264",
        countryCode: "AI",
    },
    {
        countryName: "Antigua and Barbuda",
        phoneCode: "+1268",
        countryCode: "AG",
    },
    {
        countryName: "Argentina",
        phoneCode: "+54",
        countryCode: "AR",
    },
    {
        countryName: "Armenia",
        phoneCode: "+374",
        countryCode: "AM",
    },
    {
        countryName: "Aruba",
        phoneCode: "+297",
        countryCode: "AW",
    },
    {
        countryName: "Australia",
        phoneCode: "+61",
        countryCode: "AU",
    },
    {
        countryName: "Austria",
        phoneCode: "+43",
        countryCode: "AT",
    },
    {
        countryName: "Azerbaijan",
        phoneCode: "+994",
        countryCode: "AZ",
    },
    {
        countryName: "Bahamas",
        phoneCode: "+1242",
        countryCode: "BS",
    },
    {
        countryName: "Bahrain",
        phoneCode: "+973",
        countryCode: "BH",
    },
    {
        countryName: "Bangladesh",
        phoneCode: "+880",
        countryCode: "BD",
    },
    {
        countryName: "Barbados",
        phoneCode: "+1 246",
        countryCode: "BB",
    },
    {
        countryName: "Belarus",
        phoneCode: "+375",
        countryCode: "BY",
    },
    {
        countryName: "Belgium",
        phoneCode: "+32",
        countryCode: "BE",
    },
    {
        countryName: "Belize",
        phoneCode: "+501",
        countryCode: "BZ",
    },
    {
        countryName: "Benin",
        phoneCode: "+229",
        countryCode: "BJ",
    },
    {
        countryName: "Bermuda",
        phoneCode: "+1441",
        countryCode: "BM",
    },
    {
        countryName: "Bhutan",
        phoneCode: "+975",
        countryCode: "BT",
    },
    {
        countryName: "Bosnia and Herzegovina",
        phoneCode: "+387",
        countryCode: "BA",
    },
    {
        countryName: "Botswana",
        phoneCode: "+267",
        countryCode: "BW",
    },
    {
        countryName: "Brazil",
        phoneCode: "+55",
        countryCode: "BR",
    },
    {
        countryName: "British Indian Ocean Territory",
        phoneCode: "+246",
        countryCode: "IO",
    },
    {
        countryName: "Bulgaria",
        phoneCode: "+359",
        countryCode: "BG",
    },
    {
        countryName: "Burkina Faso",
        phoneCode: "+226",
        countryCode: "BF",
    },
    {
        countryName: "Burundi",
        phoneCode: "+257",
        countryCode: "BI",
    },
    {
        countryName: "Cambodia",
        phoneCode: "+855",
        countryCode: "KH",
    },
    {
        countryName: "Cameroon",
        phoneCode: "+237",
        countryCode: "CM",
    },
    {
        countryName: "Canada",
        phoneCode: "+1",
        countryCode: "CA",
    },
    {
        countryName: "Cape Verde",
        phoneCode: "+238",
        countryCode: "CV",
    },
    {
        countryName: "Cayman Islands",
        phoneCode: "+ 345",
        countryCode: "KY",
    },
    {
        countryName: "Central African Republic",
        phoneCode: "+236",
        countryCode: "CF",
    },
    {
        countryName: "Chad",
        phoneCode: "+235",
        countryCode: "TD",
    },
    {
        countryName: "Chile",
        phoneCode: "+56",
        countryCode: "CL",
    },
    {
        countryName: "China",
        phoneCode: "+86",
        countryCode: "CN",
    },
    {
        countryName: "Christmas Island",
        phoneCode: "+61",
        countryCode: "CX",
    },
    {
        countryName: "Colombia",
        phoneCode: "+57",
        countryCode: "CO",
    },
    {
        countryName: "Comoros",
        phoneCode: "+269",
        countryCode: "KM",
    },
    {
        countryName: "Congo",
        phoneCode: "+242",
        countryCode: "CG",
    },
    {
        countryName: "Cook Islands",
        phoneCode: "+682",
        countryCode: "CK",
    },
    {
        countryName: "Costa Rica",
        phoneCode: "+506",
        countryCode: "CR",
    },
    {
        countryName: "Croatia",
        phoneCode: "+385",
        countryCode: "HR",
    },
    {
        countryName: "Cuba",
        phoneCode: "+53",
        countryCode: "CU",
    },
    {
        countryName: "Cyprus",
        phoneCode: "+357",
        countryCode: "CY",
    },
    {
        countryName: "Czech Republic",
        phoneCode: "+420",
        countryCode: "CZ",
    },
    {
        countryName: "Denmark",
        phoneCode: "+45",
        countryCode: "DK",
    },
    {
        countryName: "Djibouti",
        phoneCode: "+253",
        countryCode: "DJ",
    },
    {
        countryName: "Dominica",
        phoneCode: "+1767",
        countryCode: "DM",
    },
    {
        countryName: "Dominican Republic",
        phoneCode: "+1 849",
        countryCode: "DO",
    },
    {
        countryName: "Ecuador",
        phoneCode: "+593",
        countryCode: "EC",
    },
    {
        countryName: "Egypt",
        phoneCode: "+20",
        countryCode: "EG",
    },
    {
        countryName: "El Salvador",
        phoneCode: "+503",
        countryCode: "SV",
    },
    {
        countryName: "Equatorial Guinea",
        phoneCode: "+240",
        countryCode: "GQ",
    },
    {
        countryName: "Eritrea",
        phoneCode: "+291",
        countryCode: "ER",
    },
    {
        countryName: "Estonia",
        phoneCode: "+372",
        countryCode: "EE",
    },
    {
        countryName: "Ethiopia",
        phoneCode: "+251",
        countryCode: "ET",
    },
    {
        countryName: "Faroe Islands",
        phoneCode: "+298",
        countryCode: "FI",
    },
    {
        countryName: "Fiji",
        phoneCode: "+679",
        countryCode: "FJ",
    },
    {
        countryName: "Finland",
        phoneCode: "+358",
        countryCode: "FI",
    },
    {
        countryName: "France",
        phoneCode: "+33",
        countryCode: "FR",
    },
    {
        countryName: "French Guiana",
        phoneCode: "+594",
        countryCode: "GF",
    },
    {
        countryName: "French Polynesia",
        phoneCode: "+689",
        countryCode: "PF",
    },
    {
        countryName: "Gabon",
        phoneCode: "+241",
        countryCode: "GA",
    },
    {
        countryName: "Gambia",
        phoneCode: "+220",
        countryCode: "GM",
    },
    {
        countryName: "Georgia",
        phoneCode: "+995",
        countryCode: "GE",
    },
    {
        countryName: "Germany",
        phoneCode: "+49",
        countryCode: "DE",
    },
    {
        countryName: "Ghana",
        phoneCode: "+233",
        countryCode: "GH",
    },
    {
        countryName: "Gibraltar",
        phoneCode: "+350",
        countryCode: "GI",
    },
    {
        countryName: "Greece",
        phoneCode: "+30",
        countryCode: "GR",
    },
    {
        countryName: "Greenland",
        phoneCode: "+299",
        countryCode: "GL",
    },
    {
        countryName: "Grenada",
        phoneCode: "+1473",
        countryCode: "GD",
    },
    {
        countryName: "Guadeloupe",
        phoneCode: "+590",
        countryCode: "GP",
    },
    {
        countryName: "Guam",
        phoneCode: "+1671",
        countryCode: "GU",
    },
    {
        countryName: "Guatemala",
        phoneCode: "+502",
        countryCode: "GT",
    },
    {
        countryName: "Guinea",
        phoneCode: "+224",
        countryCode: "GN",
    },
    {
        countryName: "Guinea-Bissau",
        phoneCode: "+245",
        countryCode: "GW",
    },
    {
        countryName: "Guyana",
        phoneCode: "+592",
        countryCode: "GY",
    },
    {
        countryName: "Haiti",
        phoneCode: "+509",
        countryCode: "HT",
    },
    {
        countryName: "Honduras",
        phoneCode: "+504",
        countryCode: "HN",
    },
    {
        countryName: "Hungary",
        phoneCode: "+36",
        countryCode: "HU",
    },
    {
        countryName: "Iceland",
        phoneCode: "+354",
        countryCode: "IS",
    },
    {
        countryName: "India",
        phoneCode: "+91",
        countryCode: "IN",
    },
    {
        countryName: "Indonesia",
        phoneCode: "+62",
        countryCode: "ID",
    },
    {
        countryName: "Iraq",
        phoneCode: "+964",
        countryCode: "IQ",
    },
    {
        countryName: "Ireland",
        phoneCode: "+353",
        countryCode: "IE",
    },
    {
        countryName: "Israel",
        phoneCode: "+972",
        countryCode: "IL",
    },
    {
        countryName: "Italy",
        phoneCode: "+39",
        countryCode: "IT",
    },
    {
        countryName: "Jamaica",
        phoneCode: "+1 876",
        countryCode: "JM",
    },
    {
        countryName: "Japan",
        phoneCode: "+81",
        countryCode: "JP",
    },
    {
        countryName: "Jordan",
        phoneCode: "+962",
        countryCode: "JO",
    },
    {
        countryName: "Kazakhstan",
        phoneCode: "+7 7",
        countryCode: "KZ",
    },
    {
        countryName: "Kenya",
        phoneCode: "+254",
        countryCode: "KE",
    },
    {
        countryName: "Kiribati",
        phoneCode: "+686",
        countryCode: "KI",
    },
    {
        countryName: "Kuwait",
        phoneCode: "+965",
        countryCode: "KW",
    },
    {
        countryName: "Kyrgyzstan",
        phoneCode: "+996",
        countryCode: "KG",
    },
    {
        countryName: "Latvia",
        phoneCode: "+371",
        countryCode: "LV",
    },
    {
        countryName: "Lebanon",
        phoneCode: "+961",
        countryCode: "LB",
    },
    {
        countryName: "Lesotho",
        phoneCode: "+266",
        countryCode: "LS",
    },
    {
        countryName: "Liberia",
        phoneCode: "+231",
        countryCode: "LR",
    },
    {
        countryName: "Liechtenstein",
        phoneCode: "+423",
        countryCode: "LI",
    },
    {
        countryName: "Lithuania",
        phoneCode: "+370",
        countryCode: "LT",
    },
    {
        countryName: "Luxembourg",
        phoneCode: "+352",
        countryCode: "LU",
    },
    {
        countryName: "Madagascar",
        phoneCode: "+261",
        countryCode: "MG",
    },
    {
        countryName: "Malawi",
        phoneCode: "+265",
        countryCode: "MW",
    },
    {
        countryName: "Malaysia",
        phoneCode: "+60",
        countryCode: "MY",
    },
    {
        countryName: "Maldives",
        phoneCode: "+960",
        countryCode: "MV",
    },
    {
        countryName: "Mali",
        phoneCode: "+223",
        countryCode: "ML",
    },
    {
        countryName: "Malta",
        phoneCode: "+356",
        countryCode: "MT",
    },
    {
        countryName: "Marshall Islands",
        phoneCode: "+692",
        countryCode: "MH",
    },
    {
        countryName: "Martinique",
        phoneCode: "+596",
        countryCode: "MQ",
    },
    {
        countryName: "Mauritania",
        phoneCode: "+222",
        countryCode: "MR",
    },
    {
        countryName: "Mauritius",
        phoneCode: "+230",
        countryCode: "MU",
    },
    {
        countryName: "Mayotte",
        phoneCode: "+262",
        countryCode: "YT",
    },
    {
        countryName: "Mexico",
        phoneCode: "+52",
        countryCode: "MX",
    },
    {
        countryName: "Monaco",
        phoneCode: "+377",
        countryCode: "MC",
    },
    {
        countryName: "Mongolia",
        phoneCode: "+976",
        countryCode: "MN",
    },
    {
        countryName: "Montenegro",
        phoneCode: "+382",
        countryCode: "ME",
    },
    {
        countryName: "Montserrat",
        phoneCode: "+1664",
        countryCode: "MS",
    },
    {
        countryName: "Morocco",
        phoneCode: "+212",
        countryCode: "MA",
    },
    {
        countryName: "Myanmar",
        phoneCode: "+95",
        countryCode: "MM",
    },
    {
        countryName: "Namibia",
        phoneCode: "+264",
        countryCode: "NA",
    },
    {
        countryName: "Nauru",
        phoneCode: "+674",
        countryCode: "NR",
    },
    {
        countryName: "Nepal",
        phoneCode: "+977",
        countryCode: "NP",
    },
    {
        countryName: "Netherlands",
        phoneCode: "+31",
        countryCode: "NL",
    },
    // TODO ask
    /*{
        countryName: 'Netherlands Antilles',
        phoneCode: '+599',
        countryCode: 'AN',
      },*/
    {
        countryName: "New Caledonia",
        phoneCode: "+687",
        countryCode: "NC",
    },
    {
        countryName: "New Zealand",
        phoneCode: "+64",
        countryCode: "NZ",
    },
    {
        countryName: "Nicaragua",
        phoneCode: "+505",
        countryCode: "NI",
    },
    {
        countryName: "Niger",
        phoneCode: "+227",
        countryCode: "NE",
    },
    {
        countryName: "Nigeria",
        phoneCode: "+234",
        countryCode: "NG",
    },
    {
        countryName: "Niue",
        phoneCode: "+683",
        countryCode: "NU",
    },
    {
        countryName: "Northern Mariana Islands",
        phoneCode: "+1670",
        countryCode: "MP",
    },
    {
        countryName: "Norway",
        phoneCode: "+47",
        countryCode: "NO",
    },
    {
        countryName: "Oman",
        phoneCode: "+968",
        countryCode: "OM",
    },
    {
        countryName: "Pakistan",
        phoneCode: "+92",
        countryCode: "PK",
    },
    {
        countryName: "Palau",
        phoneCode: "+680",
        countryCode: "PW",
    },
    {
        countryName: "Panama",
        phoneCode: "+507",
        countryCode: "PA",
    },
    {
        countryName: "Papua New Guinea",
        phoneCode: "+675",
        countryCode: "PG",
    },
    {
        countryName: "Paraguay",
        phoneCode: "+595",
        countryCode: "PY",
    },
    {
        countryName: "Peru",
        phoneCode: "+51",
        countryCode: "PE",
    },
    {
        countryName: "Philippines",
        phoneCode: "+63",
        countryCode: "PH",
    },
    {
        countryName: "Poland",
        phoneCode: "+48",
        countryCode: "PL",
    },
    {
        countryName: "Portugal",
        phoneCode: "+351",
        countryCode: "PT",
    },
    {
        countryName: "Puerto Rico",
        phoneCode: "+1939",
        countryCode: "PR",
    },
    {
        countryName: "Qatar",
        phoneCode: "+974",
        countryCode: "QA",
    },
    {
        countryName: "Romania",
        phoneCode: "+40",
        countryCode: "RO",
    },
    {
        countryName: "Rwanda",
        phoneCode: "+250",
        countryCode: "RW",
    },
    {
        countryName: "Samoa",
        phoneCode: "+685",
        countryCode: "WS",
    },
    {
        countryName: "San Marino",
        phoneCode: "+378",
        countryCode: "SM",
    },
    {
        countryName: "Saudi Arabia",
        phoneCode: "+966",
        countryCode: "SA",
    },
    {
        countryName: "Senegal",
        phoneCode: "+221",
        countryCode: "SN",
    },
    {
        countryName: "Serbia",
        phoneCode: "+381",
        countryCode: "RS",
    },
    {
        countryName: "Seychelles",
        phoneCode: "+248",
        countryCode: "SC",
    },
    {
        countryName: "Sierra Leone",
        phoneCode: "+232",
        countryCode: "SL",
    },
    {
        countryName: "Singapore",
        phoneCode: "+65",
        countryCode: "SG",
    },
    {
        countryName: "Slovakia",
        phoneCode: "+421",
        countryCode: "SK",
    },
    {
        countryName: "Slovenia",
        phoneCode: "+386",
        countryCode: "SI",
    },
    {
        countryName: "Solomon Islands",
        phoneCode: "+677",
        countryCode: "SB",
    },
    {
        countryName: "South Africa",
        phoneCode: "+27",
        countryCode: "ZA",
    },
    {
        countryName: "South Georgia and the South Sandwich Islands",
        phoneCode: "+500",
        countryCode: "GS",
    },
    {
        countryName: "Spain",
        phoneCode: "+34",
        countryCode: "ES",
    },
    {
        countryName: "Sri Lanka",
        phoneCode: "+94",
        countryCode: "LK",
    },
    {
        countryName: "Sudan",
        phoneCode: "+249",
        countryCode: "SD",
    },
    {
        countryName: "Surinami",
        phoneCode: "+597",
        countryCode: "SR",
    },
    {
        countryName: "Swaziland",
        phoneCode: "+268",
        countryCode: "SZ",
    },
    {
        countryName: "Sweden",
        phoneCode: "+46",
        countryCode: "SE",
    },
    {
        countryName: "Switzerland",
        phoneCode: "+41",
        countryCode: "CH",
    },
    {
        countryName: "Tajikistan",
        phoneCode: "+992",
        countryCode: "TJ",
    },
    {
        countryName: "Thailand",
        phoneCode: "+66",
        countryCode: "TH",
    },
    {
        countryName: "Togo",
        phoneCode: "+228",
        countryCode: "TG",
    },
    {
        countryName: "Tokelau",
        phoneCode: "+690",
        countryCode: "TK",
    },
    {
        countryName: "Tonga",
        phoneCode: "+676",
        countryCode: "TO",
    },
    {
        countryName: "Trinidad and Tobago",
        phoneCode: "+1868",
        countryCode: "TT",
    },
    {
        countryName: "Tunisia",
        phoneCode: "+216",
        countryCode: "TN",
    },
    {
        countryName: "Turkey",
        phoneCode: "+90",
        countryCode: "TR",
    },
    {
        countryName: "Turkmenistan",
        phoneCode: "+993",
        countryCode: "TM",
    },
    {
        countryName: "Turks and Caicos Islands",
        phoneCode: "+1649",
        countryCode: "TC",
    },
    {
        countryName: "Tuvalu",
        phoneCode: "+688",
        countryCode: "TV",
    },
    {
        countryName: "Uganda",
        phoneCode: "+256",
        countryCode: "UG",
    },
    {
        countryName: "Ukraine",
        phoneCode: "+380",
        countryCode: "UA",
    },
    {
        countryName: "United Arab Emirates",
        phoneCode: "+971",
        countryCode: "AE",
    },
    {
        countryName: "United Kingdom",
        phoneCode: "+44",
        countryCode: "GB",
    },
    {
        countryName: "United States",
        phoneCode: "+1",
        countryCode: "US",
    },
    {
        countryName: "Uruguay",
        phoneCode: "+598",
        countryCode: "UY",
    },
    {
        countryName: "Uzbekistan",
        phoneCode: "+998",
        countryCode: "UZ",
    },
    {
        countryName: "Vanuatu",
        phoneCode: "+678",
        countryCode: "VU",
    },
    {
        countryName: "Wallis and Futuna",
        phoneCode: "+681",
        countryCode: "WF",
    },
    {
        countryName: "Yemen",
        phoneCode: "+967",
        countryCode: "YE",
    },
    {
        countryName: "Zambia",
        phoneCode: "+260",
        countryCode: "ZM",
    },
    {
        countryName: "Zimbabwe",
        phoneCode: "+263",
        countryCode: "ZW",
    },
    {
        countryName: "Åland Islands",
        phoneCode: "+358",
        countryCode: "AX",
    },
    // TODO ask
    /*{
        countryName: 'Antarctica',
        phoneCode: '+672',
        countryCode: 'AQ',
      },*/
    {
        countryName: "Bolivia, Plurinational State of",
        phoneCode: "+591",
        countryCode: "BO",
    },
    {
        countryName: "Brunei Darussalam",
        phoneCode: "+673",
        countryCode: "BN",
    },
    {
        countryName: "Cocos (Keeling) Islands",
        phoneCode: "+61",
        countryCode: "CC",
    },
    {
        countryName: "Congo, The Democratic Republic of the",
        phoneCode: "+243",
        countryCode: "CD",
    },
    {
        countryName: "Cote d'Ivoire",
        phoneCode: "+225",
        countryCode: "CI",
    },
    {
        countryName: "Falkland Islands (Malvinas)",
        phoneCode: "+500",
        countryCode: "FK",
    },
    {
        countryName: "Guernsey",
        phoneCode: "+44",
        countryCode: "GG",
    },
    {
        countryName: "Holy See (Vatican City State)",
        phoneCode: "+379",
        countryCode: "VA",
    },
    {
        countryName: "Hong Kong",
        phoneCode: "+852",
        countryCode: "HK",
    },
    {
        countryName: "Iran, Islamic Republic of",
        phoneCode: "+98",
        countryCode: "IR",
    },
    {
        countryName: "Isle of Man",
        phoneCode: "+44",
        countryCode: "IM",
    },
    {
        countryName: "Jersey",
        phoneCode: "+44",
        countryCode: "JE",
    },
    {
        countryName: "Korea, Democratic People's Republic of",
        phoneCode: "+850",
        countryCode: "KP",
    },
    {
        countryName: "Korea, Republic of",
        phoneCode: "+82",
        countryCode: "KR",
    },
    {
        countryName: "Lao People's Democratic Republic",
        phoneCode: "+856",
        countryCode: "LA",
    },
    {
        countryName: "Libyan Arab Jamahiriya",
        phoneCode: "+218",
        countryCode: "LY",
    },
    {
        countryName: "Macao",
        phoneCode: "+853",
        countryCode: "MO",
    },
    {
        countryName: "Macedonia, The Former Yugoslav Republic of",
        phoneCode: "+389",
        countryCode: "MK",
    },
    {
        countryName: "Micronesia, Federated States of",
        phoneCode: "+691",
        countryCode: "FM",
    },
    {
        countryName: "Moldova, Republic of",
        phoneCode: "+373",
        countryCode: "MD",
    },
    {
        countryName: "Mozambique",
        phoneCode: "+258",
        countryCode: "MZ",
    },
    {
        countryName: "Palestinian Territory, Occupied",
        phoneCode: "+970",
        countryCode: "PS",
    },
    {
        countryName: "Pitcairn",
        phoneCode: "+64",
        countryCode: "PN",
    },
    {
        countryName: "Réunion",
        phoneCode: "+262",
        countryCode: "RE",
    },
    {
        countryName: "Russia",
        phoneCode: "+7",
        countryCode: "RU",
    },
    {
        countryName: "Saint Barthélemy",
        phoneCode: "+590",
        countryCode: "BL",
    },
    {
        countryName: "Saint Helena, Ascension and Tristan Da Cunha",
        phoneCode: "+290",
        countryCode: "SH",
    },
    {
        countryName: "Saint Kitts and Nevis",
        phoneCode: "+1869",
        countryCode: "KN",
    },
    {
        countryName: "Saint Lucia",
        phoneCode: "+1 758",
        countryCode: "LC",
    },
    {
        countryName: "Saint Martin",
        phoneCode: "+590",
        countryCode: "MF",
    },
    {
        countryName: "Saint Pierre and Miquelon",
        phoneCode: "+508",
        countryCode: "PM",
    },
    {
        countryName: "Saint Vincent and the Grenadines",
        phoneCode: "+1 784",
        countryCode: "VC",
    },
    {
        countryName: "Sao Tome and Principe",
        phoneCode: "+239",
        countryCode: "ST",
    },
    {
        countryName: "Somalia",
        phoneCode: "+252",
        countryCode: "SO",
    },
    {
        countryName: "Svalbard and Jan Mayen",
        phoneCode: "+47",
        countryCode: "SJ",
    },
    {
        countryName: "Syrian Arab Republic",
        phoneCode: "+963",
        countryCode: "SY",
    },
    {
        countryName: "Taiwan, Province of China",
        phoneCode: "+886",
        countryCode: "TW",
    },
    {
        countryName: "Tanzania, United Republic of",
        phoneCode: "+255",
        countryCode: "TZ",
    },
    {
        countryName: "Timor-Leste",
        phoneCode: "+670",
        countryCode: "TL",
    },
    {
        countryName: "Venezuela, Bolivarian Republic of",
        phoneCode: "+58",
        countryCode: "VE",
    },
    {
        countryName: "Viet Nam",
        phoneCode: "+84",
        countryCode: "VN",
    },
    {
        countryName: "Virgin Islands, British",
        phoneCode: "+1284",
        countryCode: "VG",
    },
    {
        countryName: "Virgin Islands, U.S.",
        phoneCode: "+1340",
        countryCode: "VI",
    },
];
exports.countryCodes = exports.COUNTRIES.map((c) => c.countryCode);
exports.phoneCodes = exports.COUNTRIES.map((c) => c.phoneCode);
// Attach regions (if available) from the generated map.
exports.COUNTRIES.forEach((country) => {
    const regions = country_regions_generated_1.COUNTRY_REGIONS[country.countryCode];
    if (regions && regions.length) {
        country.regions = regions;
    }
    // Attach tax rates (if available) from the generated map.
    const taxRate = country_tax_rates_generated_1.COUNTRY_TAX_RATES[country.countryCode];
    if (taxRate !== undefined) {
        country.taxRate = taxRate;
    }
});
